export default __webpack_public_path__ + "static/media/om.88bf7e99.jpeg";